import React, { useState } from "react";
import { useQuery } from "react-query";
import * as api from "src/services";
import {
  Card,
  CardContent,
  Grid,
  MenuItem,
  Select,
  Skeleton,
  styled,
  Typography,
} from "@mui/material";

//components
// toast
import toast from "react-hot-toast";
import { HeaderBreadcrumbs, ProductForm, Toolbar, Page } from "src/components";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LandForm from "src/components/forms/properties/landForm";
import HomeForm from "src/components/forms/properties/homeForm";
// ----------------------------------------------------------------------
const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
  span: {
    fontSize: 12,
    float: "right",
    fontWeight: 400,
  },
}));

export const formTypes = {
  plan: "Plan",
  builtHomes: "Built Homes",
  land: "Land",
};
export default function EcommerceProduct() {
  const { pid, ptype } = useParams();
  const { t } = useTranslation(["product", "common"]);
  const navigate = useNavigate();
  const [formType, setFormType] = useState(ptype || formTypes.plan);

  const {
    data: product,
    isLoading,
    isStale,
  } = useQuery(
    [`get-${ptype}-details${pid}`],
    () => api.getProductDetails({ id: pid, formType: ptype }),
    {
      enabled: Boolean(pid),
      retry: false,
      staleTime: 10 * 1000,
      onError: (error) => {
        if (!error.response.data.success) {
          navigate("/404");
        }
      },
    }
  );
  const { data, isLoading: categoryLoading } = useQuery("categories", () =>
    api.getAllCategories("")
  );

  return (
    <Page
      title={`${pid ? "Edit" : "Add"} ${formType} | ${
        process.env.REACT_APP_DOMAIN_NAME
      }`}
    >
      <Toolbar>
        <HeaderBreadcrumbs
          heading={pid ? "Edit Plan" : "Add Plan"}
          links={[
            { name: t("dashboard"), href: "/" },
            { name: ptype || formTypes.plan, href: "/products" },
            { name: pid ? "Edit" : "Add" },
          ]}
        />
      </Toolbar>
      <Grid container>
        <Grid item xs={12}>
          <Card
            sx={{
              display: "flex",
              alignItems: "center",
              p: 2,
              px: 3,
              gap: 2,
              mb: 3,
            }}
          >
            {isLoading ? (
              <Skeleton variant="text" width={140} />
            ) : (
              <LabelStyle>{"Select Form type:"}</LabelStyle>
            )}
            {!isLoading ? (
              <Select
                sx={{ minWidth: 180 }}
                size="small"
                value={formType}
                id="grouped-native-select"
                onChange={(e) => setFormType(e.target.value)}
              >
                {Object.values(formTypes)?.map((item) => (
                  <MenuItem value={item} key={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <Skeleton variant="rectangular" width={"100%"} height={56} />
            )}
          </Card>
        </Grid>

        <Grid item xs={12}>
          {formType == formTypes.plan ? (
            <ProductForm
              categories={!categoryLoading && data?.data}
              categoryLoading={categoryLoading}
              currentProduct={product?.data}
              isInitialized={isLoading || false}
            />
          ) : formType == formTypes.builtHomes ? (
            <HomeForm
              categories={!categoryLoading && data?.data}
              categoryLoading={categoryLoading}
              currentProduct={product?.data}
              isInitialized={isLoading || false}
            />
          ) : (
            <LandForm
              categoryLoading={categoryLoading}
              currentProduct={product?.data}
              isInitialized={isLoading || false}
              isLand={true}
            />
          )}
        </Grid>
      </Grid>
    </Page>
  );
}
